import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import IntegrationsGridDataProviderFactory from '../factory/IntegrationsGridDataProviderFactory';
import IntegrationsGridViewDataProvider from '../dataProvider/IntegrationsGridViewDataProvider';
import { IntegrationsGridViewData } from '../types';
import { Integration, Sensor, SensorEnabledStatus } from '../../common/types';

export default class IntegrationsGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrationsGridDataProviderFactory;
  public dataProvider: IntegrationsGridViewDataProvider;

  constructor() {
    super();

    this.initialSetup({
      dataProviderFactory: new IntegrationsGridDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<IntegrationsGridViewData> {
    return this.dataProvider.getDataForView();
  }

  async sensorSetEnabledStatus(sensor: Sensor, enabledStatus: SensorEnabledStatus): Promise<object> {
    return await this.dataProvider.sensorSetEnabledStatus(sensor, enabledStatus);
  }

  async setEnabledStatus(integration: Integration, enabledStatus: SensorEnabledStatus): Promise<object> {
    return await this.dataProvider.setEnabledStatus(integration, enabledStatus);
  }

  async remove(integration: Integration): Promise<void> {
    await this.dataProvider.remove(integration);
  }

  async deleteSensor(sensor: Sensor): Promise<void> {
    await this.dataProvider.deleteSensor(sensor);
  }
}
